import styles from "./LocalErrorDisplay.module.css";

const SUPPORT_EMAIL = "connect@ignite-elysium.com";

const DEFAULT_TITLE = "Oh no!";
const DEFAULT_LEAD =
  "We are having trouble loading music for this page. It is usually temporary. A quick refresh often clears it.";

/**
 * Friendly, themed local error panel for recoverable app/data failures.
 * Props: title?, message?, lead?
 */
const LocalErrorDisplay = (props) => {
  const title = props.title || DEFAULT_TITLE;
  const lead = props.lead || DEFAULT_LEAD;
  const message =
    typeof props.message === "string" && props.message.trim()
      ? props.message.trim()
      : null;

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";
  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";

  const mailBody = [
    "Hi there,",
    "",
    "I ran into a problem on the Ignite Elysium Music site.",
    "",
    "What I saw:",
    message || "(no extra details)",
    "",
    `Page: ${pageUrl}`,
    `Browser: ${userAgent}`,
    "",
    "Thanks!",
  ].join("\n");

  const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    "Ignite Elysium Music — site issue",
  )}&body=${encodeURIComponent(mailBody)}`;

  const handleRefresh = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  return (
    <div className={styles.panel} role="alert" aria-live="assertive">
      <div className={styles.rail} aria-hidden="true" />

      <header className={styles.header}>
        <p className={styles.eyebrow}>Error</p>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.lead}>{lead}</p>
      </header>

      {message && (
        <section className={styles.detail} aria-label="Error details">
          <p className={styles.detailLabel}>Details</p>
          <p className={styles.detailBody}>{message}</p>
        </section>
      )}

      <section className={styles.tips} aria-label="Things to try">
        {/* <p className={styles.tipsHeading}>Things to try</p> */}
        {/* <ul className={styles.tipsList}>
          <li>Make sure you are connected to the internet</li>
          <li>Refresh the page and try again</li>
          <li>
            If it keeps happening for more than about 30 minutes, please let us
            know by emailing support
          </li>
        </ul> */}
        <p className={styles.tipsList}>
          If the problem persists, please let us know by clicking the "Pre-Made
          Support Email" button below or by emailing us directly.
        </p>
      </section>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={handleRefresh}
        >
          Refresh page
        </button>
        <a className={styles.secondaryBtn} href={mailtoHref}>
          Pre-Made Support Email
        </a>
      </div>

      <p className={styles.footnote}>
        Prefer to send directly? <br />
        Email:{" "}
        <a className={styles.inlineLink} href={mailtoHref}>
          {SUPPORT_EMAIL}
        </a>
        <br /> Be sure to include the details of the issue.
      </p>
    </div>
  );
};

export default LocalErrorDisplay;
